/* src/app/indirect-rate/indirect-rate-review/indirect-rate-review-container/indirect-rate-review-container.component.scss */
/*# sourceMappingURL=indirect-rate-review-container.component.css.map */
